import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $types } from './FootPrintApiManager.types'

@Injectable({ providedIn: 'root' })
export class FootPrintApiManager_rabbit_mq_pushService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { connection: string, folder: string, transit?: string, transaction_id?: string, test?: boolean, files: { file_name?: string, file_blob?: any }[] }): Promise<{ messages?: any[], success?: boolean }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.connection)) {
      missingRequiredInParams.push('\'connection\'');
    }
    if (isNil(inParams.folder)) {
      missingRequiredInParams.push('\'folder\'');
    }
    if (isNil(inParams.files)) {
      missingRequiredInParams.push('\'files\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/FootPrintApiManager/functions/rabbit_mq_push`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

